import React from 'react';
import { Tag } from 'antd';
export const submissionLabels = { pending: '处理中 / 待核对', accepted: '伙伴通已接收', rejected: '伙伴通拒绝',
  unknown: '接收结果待确认', blocked: '未提交', legacy: '历史推送记录' };
export default function SubmissionStatus({ status }) {
  const colors = { accepted: 'green', rejected: 'red', unknown: 'orange', pending: 'processing', blocked: 'default' };
  return <Tag color={colors[status] || 'default'}>{submissionLabels[status] || submissionLabels.legacy}</Tag>;
}
